import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { WrapContent } from 'app/components/WrapContent';
import useAxios from 'axios-hooks';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { notification } from 'utils/notification';
import './styles.scss';

const List = React.lazy(() => import('./List'));
const CreateEditView = React.lazy(() => import('./CreateEditView'));
const PaymentInstance = React.lazy(() => import('./PaymentInstance'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'UserServiceManager_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const UserServiceManager = () => {
  const { t }: any = useDictionary({ programId: 'user-service' });
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState<any>({
    type: 'list',
    data: null,
    isCreateDone: false,
  });

  const [{ loading }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  useEffect(() => {
    onSubmit();
  }, []);

  useEffect(() => {
    if (modeView?.type === 'list' && modeView?.isCreateDone) {
      setModeView(prev => {
        prev.isCreateDone = false;
        return prev;
      });
      onSubmit();
    }
  }, [modeView]);

  /**
   * on submit
   *
   */
  const onSubmit = async () => {
    const res = await refetchData({
      url: '/service/user/service-and-instance',
      method: 'GET',
    });
    if (res?.data?.status === '200') {
      const { services, instances } = res?.data?.data || {};
      (services || []).forEach(s => {
        s.instances = (instances || []).filter(
          i => i.serviceId === s.serviceId,
        );
      });
      setData(services || []);
    } else {
      notification({ res });
    }
  };

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    onSubmit,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'create':
        return <CreateEditView />;
      case 'payment':
        return <PaymentInstance />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <WrapContent>
      <ModuleContext.Provider value={value}>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={loading} />
          {renderContent()}
        </React.Suspense>
      </ModuleContext.Provider>
    </WrapContent>
  );
};

export default UserServiceManager;
